import script from "./PubInfoBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./PubInfoBar.vue?vue&type=script&setup=true&lang=ts"

import "./PubInfoBar.vue?vue&type=style&index=0&id=85593fac&lang=scss"

const __exports__ = script;

export default __exports__